import api from '../helpers/api';
export var get = function (url) { return api.get("/" + url); };
export var post = function (url, params) { return api.post("/" + url, params); };
export var put = function (url, params) { return api.put("/" + url, params); };
